import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["teacherSelector"]

  connect() {
  }

  showTeacherSelector(event) {
    event.preventDefault()

    const mainOdontogramContent = this.element.querySelector('.flex.gap-4')
    const hrElement = this.element.querySelector('hr')
    const antecedentesSection = hrElement ? hrElement.nextElementSibling : null

    if (mainOdontogramContent) {
      mainOdontogramContent.style.display = "none"
    }
    if (antecedentesSection) {
      antecedentesSection.style.display = "none"
    }

    if (this.hasTeacherSelectorTarget) {
      this.teacherSelectorTarget.style.display = "block"
    }
  }

  hideTeacherSelector(event) {
    event.preventDefault()

    if (this.hasTeacherSelectorTarget) {
      this.teacherSelectorTarget.style.display = "none"
    }

    const mainOdontogramContent = this.element.querySelector('.flex.gap-4')
    const hrElement = this.element.querySelector('hr')
    const antecedentesSection = hrElement ? hrElement.nextElementSibling : null

    if (mainOdontogramContent) {
      mainOdontogramContent.style.display = "flex"
    }
    if (antecedentesSection) {
      antecedentesSection.style.display = "flex"
    }
  }

  validateTeacherForm(event) {
    const form = event.target.closest('form')
    const teacherSelect = form.querySelector('select[name*="user_id"]')

    if (!teacherSelect.value) {
      event.preventDefault()
      alert('Debes seleccionar un profesor antes de enviar el odontograma')
      return false
    }
  }
}
